'use client';
import React, { useState, useEffect } from 'react';
import { X, Wifi, MapPin, Clock, CalendarDays } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const STORAGE_KEY = 'mps_intro_dismissed_v1';

export function IntroBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="card-parchment rounded-2xl p-5 border border-accent/30 relative">
      <button
        onClick={dismiss}
        aria-label="Schließen"
        className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
      >
        <X size={16} />
      </button>
      <h2 className="font-display text-base font-bold text-primary tracking-wide mb-2">
        🏰 Warum diese App?
      </h2>
      <p className="text-sm text-foreground/80 leading-relaxed mb-3">
        Das MPS ist großartig — aber wer kennt das nicht:
      </p>
      <ul className="space-y-2 mb-3">
        {[
          { icon: Wifi, text: 'Kein Empfang auf dem Gelände — und der Spielplan ist nur online.' },
          { icon: CalendarDays, text: 'Den ausgedruckten Veranstaltungsplan hat man natürlich zuhause vergessen.' },
          { icon: MapPin, text: 'Man weiß nicht, wo man auf dem Gelände gerade ist.' },
          { icon: Clock, text: 'Eine Lieblingsband verpasst, weil man die Zeit völlig vergessen hat.' },
        ]?.map(({ icon: Icon, text }, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm text-muted-foreground">
            <Icon size={14} className="flex-shrink-0 mt-0.5 text-accent" />
            <span>{text}</span>
          </li>
        ))}
      </ul>
      <p className="text-sm text-foreground/80 leading-relaxed">
        Deshalb ist dieses Projekt entstanden — ein <strong className="text-primary">privater, kostenloser Fan-Begleiter</strong> für alle MPS-Standorte. Offline nutzbar, mit Spielplan, Karte, Wetter und Favoriten.
      </p>
      <button
        onClick={dismiss}
        className="mt-4 text-xs text-muted-foreground hover:text-foreground underline underline-offset-2 transition-colors"
      >
        Verstanden, nicht mehr anzeigen
      </button>
    </div>
  );
}

export default IntroBanner;
